{
  "auth": {
    "login": {
      "title": "Accedi",
      "noAccount": "Non hai un account?",
      "registerLink": "Registrati",
      "forgotPassword": "Password dimenticata?",
      "submit": "ACCEDI",
      "email": {
        "label": "Email",
        "placeholder": "email@example.com"
      },
      "password": {
        "label": "Password",
        "placeholder": "La tua password"
      }
    },
    "register": {
      "title": "Registrati",
      "hasAccount": "Hai già un account?",
      "loginLink": "Accedi",
      "submit": "Registrati",
      "accountInfo": "Informazioni account",
      "baseInfo": "Informazioni base",
      "residence": "Residenza",
      "domicile": "Domicilio",
      "private": "Privato",
      "company": "Azienda",
      "domicileDifferent": "Domicilio diverso da residenza",
      "privacyConsent": "Acconsento al trattamento legge sulla Privacy GDPR *",
      "dataConsent": "Acconsento al trattamento dati personali *",
      "successMessage": "Registrazione effettuata. Controlla la tua casella email per attivare il tuo account",
      "email": {
        "label": "Email",
        "placeholder": "email@example.com"
      },
      "emailConfirm": {
        "label": "Ripeti email",
        "placeholder": "email@example.com"
      },
      "password": {
        "label": "Password",
        "placeholder": "La tua password"
      },
      "passwordConfirm": {
        "label": "Ripeti password",
        "placeholder": "La tua password"
      },
      "firstName": {
        "label": "Nome",
        "placeholder": "Il tuo nome"
      },
      "lastName": {
        "label": "Cognome",
        "placeholder": "Il tuo cognome"
      },
      "vatTaxNumber": {
        "labelCompany": "Partita IVA",
        "labelPrivate": "Codice fiscale",
        "placeholderCompany": "Partita IVA",
        "placeholderPrivate": "Codice fiscale",
        "description": "Obbligatorio per residenze in Italia"
      },
      "companyName": {
        "label": "Ragione sociale",
        "placeholder": "Ragione sociale dell'azienda"
      },
      "gender": {
        "label": "Sesso",
        "placeholder": "Sesso",
        "male": "Maschio",
        "female": "Femmina"
      },
      "pec": {
        "label": "PEC",
        "placeholder": "PEC"
      },
      "sdi": {
        "label": "SDI",
        "placeholder": "SDI"
      },
      "phone": {
        "label": "Telefono",
        "placeholder": "+39 123456789"
      },
      "height": {
        "label": "Altezza (cm)",
        "placeholder": "Altezza (cm)"
      },
      "birthDate": {
        "label": "Data di nascita",
        "placeholder": "Data di nascita"
      },
      "birthCity": {
        "label": "Città di nascita",
        "placeholder": "Città di nascita"
      },
      "nationality": {
        "label": "Nazionalità",
        "placeholder": "Nazionalità"
      },
      "country": {
        "label": "Nazione residenza",
        "placeholder": "Nazione residenza"
      },
      "province": {
        "label": "Provincia residenza",
        "placeholder": "Provincia residenza"
      },
      "city": {
        "label": "Città",
        "placeholderResidence": "Città residenza",
        "placeholderDomicile": "Città domicilio"
      },
      "zip": {
        "label": "CAP residenza",
        "placeholder": "CAP residenza"
      },
      "address": {
        "label": "Indirizzo",
        "placeholderResidence": "Indirizzo residenza",
        "placeholderDomicile": "Indirizzo domicilio"
      },
      "domicileCountry": {
        "placeholder": "Nazione domicilio"
      },
      "domicileProvince": {
        "placeholder": "Provincia domicilio"
      },
      "domicileCity": {
        "placeholder": "Città domicilio"
      },
      "domicileZip": {
        "placeholder": "CAP domicilio"
      },
      "validation": {
        "emailMismatch": "Le email non corrispondono",
        "passwordMismatch": "Le password non corrispondono"
      }
    },
    "passwordReset": {
      "title": "Recupera password",
      "knowPassword": "Sai già la tua password?",
      "loginLink": "Accedi",
      "enterNewPassword": "Inserisci una nuova password.",
      "newPassword": {
        "label": "Nuova password",
        "placeholder": "La tua nuova password"
      },
      "passwordConfirm": {
        "label": "Ripeti password",
        "placeholder": "La tua nuova password"
      },
      "submit": "Conferma",
      "invalidToken": "Link di ripristino password non valido o scaduto.",
      "requestNew": "Richiedine uno nuovo",
      "successMessage": "Password reimpostata con successo",
      "validation": {
        "passwordMismatch": "Le password non corrispondono."
      }
    },
    "passwordResetRequest": {
      "title": "Recupera password",
      "knowPassword": "Sai già la tua password?",
      "loginLink": "Accedi",
      "instructions": "Inserisci l'email con la quale ti sei registrato e riceverai un link per ripristinare la tua password.",
      "email": {
        "label": "Email",
        "placeholder": "email@example.com"
      },
      "submit": "RECUPERA PASSWORD",
      "successMessage": "Controlla la tua casella email per le istruzioni su come reimpostare la password"
    },
    "activateAccount": {
      "title": "Concludi registrazione",
      "instructions": "Imposta la password per proseguire",
      "password": {
        "label": "Password",
        "placeholder": "La tua password"
      },
      "passwordConfirm": {
        "label": "Ripeti password",
        "placeholder": "La tua password"
      },
      "submit": "Conferma",
      "invalidToken": "Token non valido o scaduto",
      "verified": "Il tuo account è stato correttamente verificato",
      "validation": {
        "passwordMismatch": "Le password non corrispondono."
      }
    }
  },
  "home": {
    "welcome": "Benvenuto",
    "tabs": {
      "wishlist": "Lista dei desideri",
      "bookings": "Prenotazioni",
      "account": "Account",
      "editPassword": "Modifica password"
    }
  },
  "account": {
    "title": "Account",
    "type": {
      "private": "Privato",
      "company": "Azienda"
    },
    "logout": "Logout",
    "baseInfo": "Informazioni base",
    "residence": "Residenza",
    "domicile": "Domicilio",
    "domicileDifferent": "Domicilio diverso da residenza",
    "update": "AGGIORNA",
    "successMessage": "Informazioni aggiornate con successo!",
    "loadError": "Errore nel caricamento dell'account",
    "fields": {
      "firstName": {
        "label": "Nome",
        "placeholder": "Il tuo nome"
      },
      "lastName": {
        "label": "Cognome",
        "placeholder": "Il tuo cognome"
      },
      "vatTaxNumber": {
        "labelCompany": "Partita IVA",
        "labelPrivate": "Codice fiscale",
        "placeholderCompany": "Partita IVA",
        "placeholderPrivate": "Codice fiscale"
      },
      "companyName": {
        "label": "Ragione sociale",
        "placeholder": "Ragione sociale dell'azienda"
      },
      "gender": {
        "label": "Sesso",
        "placeholder": "Sesso",
        "male": "Maschio",
        "female": "Femmina"
      },
      "pec": {
        "label": "PEC",
        "placeholder": "PEC"
      },
      "sdi": {
        "label": "SDI",
        "placeholder": "SDI"
      },
      "phone": {
        "label": "Telefono",
        "placeholder": "+39 123456789"
      },
      "height": {
        "label": "Altezza (cm)",
        "placeholder": "Altezza (cm)"
      },
      "birthDate": {
        "label": "Data di nascita",
        "placeholder": "Data di nascita"
      },
      "birthCity": {
        "label": "Città di nascita",
        "placeholder": "Città di nascita"
      },
      "nationality": {
        "label": "Nazionalità",
        "placeholder": "Nazionalità"
      },
      "country": {
        "placeholder": "Nazione residenza"
      },
      "province": {
        "placeholder": "Provincia residenza"
      },
      "city": {
        "label": "Città",
        "placeholderResidence": "Città residenza",
        "placeholderDomicile": "Città domicilio"
      },
      "zip": {
        "placeholder": "CAP residenza"
      },
      "address": {
        "label": "Indirizzo",
        "placeholderResidence": "Indirizzo residenza",
        "placeholderDomicile": "Indirizzo domicilio"
      },
      "domicileCountry": {
        "placeholder": "Nazione domicilio"
      },
      "domicileProvince": {
        "placeholder": "Provincia domicilio"
      },
      "domicileCity": {
        "placeholder": "Città domicilio"
      },
      "domicileZip": {
        "placeholder": "CAP domicilio"
      }
    }
  },
  "editPassword": {
    "title": "Modifica password",
    "oldPassword": {
      "label": "Vecchia password",
      "placeholder": "La tua password attuale"
    },
    "newPassword": {
      "label": "Nuova password",
      "placeholder": "La tua nuova password"
    },
    "passwordConfirm": {
      "label": "Ripeti password",
      "placeholder": "Ripeti la tua nuova password"
    },
    "submit": "CONFERMA",
    "successMessage": "Password modificata con successo!",
    "validation": {
      "passwordMismatch": "Le password non corrispondono."
    }
  },
  "bookings": {
    "list": {
      "title": "Prenotazioni",
      "noRecords": "Nessuna prenotazione trovata",
      "columns": {
        "holiday": "Vacanza",
        "bookingDate": "Data prenotazione",
        "bookingStatus": "Stato prenotazione",
        "holidayStatus": "Stato vacanza",
        "paymentStatus": "Stato pagamento",
        "actions": "",
        "details": "Dettagli"
      },
      "tooltips": {
        "incompleteData": "Dati dei partecipanti incompleti",
        "viewDetails": "Visualizza dettagli"
      }
    },
    "detail": {
      "backToList": "Torna alla lista",
      "notFound": "Prenotazione con ID {id} non trovata",
      "verifying": "Stiamo verificando la tua prenotazione. Non chiudere o ricaricare la pagina.",
      "canceled": {
        "title": "Prenotazione cancellata",
        "message": "La tua prenotazione è stata cancellata. Per ulteriori informazioni contattaci.",
        "contact": "Contattaci"
      },
      "suspended": {
        "title": "Prenotazione sospesa",
        "message": "La tua prenotazione è sospesa. Per ulteriori informazioni contattaci.",
        "contact": "Contattaci"
      },
      "paymentPending": {
        "title": "Mancato pagamento",
        "message": "La tua prenotazione è in attesa di pagamento. Per completare la prenotazione, effettua il pagamento o contattaci per assistenza.",
        "depositMessage": "La tua prenotazione è in attesa di pagamento del saldo. Per completare la prenotazione, effettua il pagamento entro il {{date}}.",
        "completePayment": "Completa pagamento"
      },
      "sections": {
        "holidaySummary": "Riepilogo vacanza",
        "documents": "Documenti",
        "bookingSummary": "Riepilogo prenotazione",
        "costSummary": "Riepilogo costi"
      },
      "fields": {
        "period": "Periodo",
        "program": "Visualizza programma",
        "precontract": "Precontratto",
        "contract": "Contratto",
        "departureInfo": "Info prepartenza",
        "departureInfoByAccommodation": "Info partenza",
        "download": "Scarica",
        "fillData": "Compila dati",
        "participantData": "Compila dati: partecipante {firstName} {lastName}"
      },
      "costs": {
        "holidayCost": "Costo vacanza",
        "roomCost": "Costo camere",
        "roomWithSupplement": "Camera con supplemento",
        "extras": "Extra",
        "insurance": "Assicurazioni",
        "discount": "Sconto",
        "total": "TOTALE",
        "deposit": "ACCONTO",
        "balance": "Saldo"
      }
    },
    "participant": {
      "fields": {
        "firstName": {
          "label": "Nome"
        },
        "lastName": {
          "label": "Cognome"
        },
        "email": {
          "label": "Email",
          "placeholder": "email@example.com"
        },
        "taxCode": {
          "label": "Codice fiscale",
          "placeholder": "Codice fiscale"
        },
        "phone": {
          "label": "Telefono",
          "placeholder": "+39 123456789"
        },
        "height": {
          "label": "Altezza (cm)",
          "placeholder": "Altezza (cm)"
        },
        "birthDate": {
          "label": "Data di nascita",
          "placeholder": "Data di nascita"
        },
        "birthCity": {
          "label": "Città di nascita",
          "placeholder": "Città di nascita"
        },
        "country": {
          "placeholder": "Nazione residenza"
        },
        "province": {
          "placeholder": "Provincia residenza"
        },
        "city": {
          "label": "Città",
          "placeholder": "Città residenza"
        },
        "zip": {
          "placeholder": "CAP residenza"
        },
        "address": {
          "label": "Indirizzo",
          "placeholder": "Indirizzo residenza"
        },
        "notes": {
          "label": "Note / allergie / altre informazini",
          "placeholder": "Note / allergie / altre informazini"
        }
      },
      "info": {
        "taxCode": "CF",
        "gender": "Sesso",
        "birthDate": "Data di nascita",
        "birthCity": "Città di nascita",
        "height": "Altezza",
        "phone": "Telefono",
        "country": "Nazione",
        "province": "Provincia",
        "city": "Città",
        "zip": "CAP",
        "address": "Indirizzo",
        "notes": "Note / allergie / altre informazini",
        "room": "Camera",
        "holidayCost": "Costo vacanza",
        "roomWithSupplement": "Camera con supplemento",
        "extras": "Extra",
        "insurance": "Assicurazioni",
        "discount": "Sconto",
        "total": "TOTALE",
        "genderMale": "Maschio",
        "genderFemale": "Femmina",
        "heightUnit": "cm",
        "ensuranceNumber": "Numero polizza"
      },
      "actions": {
        "cancel": "Annulla",
        "confirm": "Conferma"
      }
    }
  },
  "wishlist": {
    "title": "Lista dei desideri",
    "empty": "Lista dei desideri vuota",
    "card": {
      "perPerson": "A persona",
      "discover": "SCOPRI",
      "remove": {
        "title": "Rimuovi vacanza",
        "message": "Stai per rimuovere la vacanza dalla lista dei desideri. \nContinuare?",
        "confirm": "Conferma",
        "cancel": "Annulla"
      }
    }
  },
  "common": {
    "buttons": {
      "confirm": "Conferma",
      "cancel": "Annulla",
      "submit": "Invia",
      "update": "Aggiorna",
      "save": "Salva",
      "delete": "Elimina",
      "edit": "Modifica",
      "close": "Chiudi",
      "back": "Indietro",
      "next": "Avanti",
      "download": "Scarica",
      "contact": "Contattaci"
    },
    "validation": {
      "required": "Campo obbligatorio",
      "invalidEmail": "Email non valida",
      "passwordMismatch": "Le password non corrispondono",
      "emailMismatch": "Le email non corrispondono",
      "unexpectedError": "Errore inatteso. Per favore riprova più tardi."
    },
    "pagination": {
      "itemsPerPage": "Elementi per pagina"
    },
    "passwordRequirements": {
      "minLength": "Deve contenere almeno 6 caratteri",
      "number": "Deve contenere almeno un numero",
      "lowercase": "Deve contenere almeno una lettera minuscola",
      "uppercase": "Deve contenere almeno una lettera maiuscola",
      "special": "Deve contenere almeno un carattere speciale"
    }
  },
  "rooms": {
    "types": {
      "single": "Singola",
      "double": "Doppia",
      "triple": "Tripla",
      "quadruple": "Quadrupla",
      "doubleSingleUse": "Doppia uso singolo",
      "doubleMatrimonial": "Doppia matrimoniale",
      "doubleBunk": "Doppia (a castello)",
      "dinette": "Dinette",
      "berth": "Cuccetta",
      "dormitory": "Camerata"
    },
    "variants": {
      "superior": "superior",
      "deluxe": "deluxe",
      "sharedBathroom": "(bagno condiviso)",
      "privateBathroom": "(bagno privato)"
    },
    "shared": {
      "shared": "condivisa",
      "male": "(maschio)",
      "female": "(femmina)",
      "info": "Camera in condivisione con partecipanti dello stesso sesso"
    }
  },
  "status": {
    "booking": {
      "confirmed": {
        "label": "Confermato",
        "tooltip": "Prenotazione confermata"
      },
      "canceled": {
        "label": "Cancellato",
        "tooltip": "Prenotazione cancellata"
      },
      "pending": {
        "label": "In attesa",
        "tooltip": "Prenotazione in attesa"
      },
      "suspended": {
        "label": "Sospesa",
        "tooltip": "Prenotazione sospesa"
      },
      "unavailable": {
        "label": "Non disponibile",
        "tooltip": "Non disponibile"
      }
    },
    "payment": {
      "paid": {
        "label": "Pagato",
        "tooltip": "Pagamento confermato"
      },
      "pendingBalance": {
        "label": "In attesa di saldo",
        "tooltip": "Pagamento in attesa di saldo"
      },
      "failed": {
        "label": "Fallito",
        "tooltip": "Pagamento fallito"
      },
      "pending": {
        "label": "In attesa",
        "tooltip": "Pagamento in attesa"
      },
      "notRequired": {
        "label": "Non richiesto",
        "tooltip": "Nessun pagamento richiesto per questa prenotazione"
      }
    },
    "holiday": {
      "confirmed": {
        "label": "Confermata",
        "tooltip": "Vacanza confermata"
      },
      "pending": {
        "label": "In fase di conferma",
        "tooltip": "Vacanza in fase di conferma"
      },
      "unavailable": {
        "label": "Non disponibile",
        "tooltip": "Vacanza non disponibile"
      }
    }
  }
}
